import React from "react";
import { BlueBirdTheme, Button, Typography } from "@kitbird/core";
import Modal from "../../../../../components/Modal";

interface ModalBankDeleteProps {
  isOpen: boolean;
  setClose: (modalState: boolean) => void;
  value: unknown;
  onSubmit: (value: unknown) => void;
}

const ModalBankDelete = ({
  isOpen, setClose, onSubmit, value,
}: ModalBankDeleteProps) => (
  <Modal
    isOpen={isOpen}
    setOpen={setClose}
    title="Konfirmasi hapus data"
    body={
      <Typography level={5} fontWeight="medium">Apakah Anda yakin ingin menghapus data?</Typography>
    }
    footer={
      <>
        <Button
          variant="text"
          onClick={() => setClose(false)}
        >
          Batal
        </Button>
        <Button
          backgroundColor={BlueBirdTheme.colors.danger[500]}
          onClick={() => setClose(false)}
        >
          Ya, hapus
        </Button>
      </>
    }
  />
);

export default ModalBankDelete;
